export default {
  salesPointsHeight: 0,
  headerHeight: 0,
};
